export const albumMarcoWiola = {
  albumTitle: "Marco & Wiola",
  albumDesc: "25 July 2018 in Delft, The Netherlands",
  photos: [
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/d8f33d75843643.5c5881e5c9a57.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/6f18a275843643.5c5881e5cb12c.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/e9f4bb75843643.5c5881e5c8b62.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/b2167f75843643.5c5881e5c7dc0.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/c96ed575843643.5c5881e5c8535.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/2e80e675843643.5c5881e5ca7f2.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/5a6b1875843643.5c5881e5c9172.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/2497cd75843643.5c5881e5cac01.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/99240775843643.5c8185ac2d4d7.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/defa5075843643.5c5881e5ca19f.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/max_3840/27643c75843643.5c8185ac2e5dd.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/max_3840/a4232275843643.5c8185ac2de0c.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/f6d8ea75843643.5c5881e5ca4d3.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/f07ca575843643.5c5881e5cb809.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/96daa075843643.5c5881e5caefc.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/f43eec75843643.5c8185ac2d8c7.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/e0974f75843643.5c5881e5c798d.jpg",
  ].map((imgURL) => ({ src: imgURL })),
};
